// extracted by mini-css-extract-plugin
export default {"lowStockLabel":"U9-z"};